function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalCapture = function SvgLocalCapture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 40"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 38"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 32",
    d: "M15.89 6.72c-1.12 0-2.16.59-2.73 1.55l-1.95 3.25c-.19.32-.54.52-.91.52H5.13c-1.17.01-2.11.95-2.12 2.12v17.01c.01 1.17.95 2.11 2.12 2.12h29.76c1.17-.01 2.11-.95 2.12-2.12V14.16a2.134 2.134 0 0 0-2.12-2.12h-5.17c-.37 0-.72-.19-.91-.51l-1.95-3.25a3.19 3.19 0 0 0-2.73-1.55l-8.22-.02ZM6.18 8.84c-.59 0-1.06.47-1.06 1.06v1.06h4.25V9.9c0-.59-.47-1.06-1.06-1.06H6.18Zm9.71 0h8.22c.37 0 .72.19.91.51l1.94 3.25c.58.96 1.62 1.55 2.74 1.55h5.17v17.01H5.12v-17h5.17c1.12 0 2.16-.59 2.73-1.55l1.94-3.25c.19-.32.54-.51.91-.51M20 15.23c-4.11 0-7.44 3.33-7.44 7.44s3.33 7.44 7.44 7.44 7.44-3.33 7.44-7.44c0-4.1-3.33-7.43-7.44-7.44m9.57 0c-.59 0-1.06.47-1.06 1.06s.47 1.06 1.06 1.06 1.06-.47 1.06-1.06-.47-1.06-1.06-1.06M20 17.35c2.94 0 5.32 2.38 5.32 5.32s-2.38 5.32-5.32 5.32-5.32-2.38-5.32-5.32c0-2.93 2.35-5.31 5.28-5.32H20",
    style: {
      fill: "#fff"
    }
  }))));
};
export default SvgLocalCapture;